// @generated by protoc-gen-connect-query v2.2.0 with parameter "target=ts,import_extension=none"
// @generated from file chalk/server/v1/offline_queries.proto (package chalk.server.v1, syntax proto3)
/* eslint-disable */

import { OfflineQueryMetadataService } from "./offline_queries_pb";

/**
 * @generated from rpc chalk.server.v1.OfflineQueryMetadataService.ListOfflineQueries
 */
export const listOfflineQueries = OfflineQueryMetadataService.method.listOfflineQueries;

/**
 * @generated from rpc chalk.server.v1.OfflineQueryMetadataService.GetOfflineQuery
 */
export const getOfflineQuery = OfflineQueryMetadataService.method.getOfflineQuery;

/**
 * @generated from rpc chalk.server.v1.OfflineQueryMetadataService.GetOfflineQueryRequestBody
 */
export const getOfflineQueryRequestBody = OfflineQueryMetadataService.method.getOfflineQueryRequestBody;

/**
 * @generated from rpc chalk.server.v1.OfflineQueryMetadataService.ListOfflineQueryShards
 */
export const listOfflineQueryShards = OfflineQueryMetadataService.method.listOfflineQueryShards;

/**
 * @generated from rpc chalk.server.v1.OfflineQueryMetadataService.GetOfflineQueryShardsAggregated
 */
export const getOfflineQueryShardsAggregated = OfflineQueryMetadataService.method.getOfflineQueryShardsAggregated;

/**
 * @generated from rpc chalk.server.v1.OfflineQueryMetadataService.GetOfflineQueryInfraSummary
 */
export const getOfflineQueryInfraSummary = OfflineQueryMetadataService.method.getOfflineQueryInfraSummary;

/**
 * @generated from rpc chalk.server.v1.OfflineQueryMetadataService.GetOfflineQueryProfileSummary
 */
export const getOfflineQueryProfileSummary = OfflineQueryMetadataService.method.getOfflineQueryProfileSummary;

/**
 * @generated from rpc chalk.server.v1.OfflineQueryMetadataService.GetOfflineQueryUtilizationSummaries
 */
export const getOfflineQueryUtilizationSummaries = OfflineQueryMetadataService.method.getOfflineQueryUtilizationSummaries;

/**
 * @generated from rpc chalk.server.v1.OfflineQueryMetadataService.GetResourceGroupUtilizationTimeseries
 */
export const getResourceGroupUtilizationTimeseries = OfflineQueryMetadataService.method.getResourceGroupUtilizationTimeseries;

/**
 * @generated from rpc chalk.server.v1.OfflineQueryMetadataService.GetResourceGroupJobTimeseries
 */
export const getResourceGroupJobTimeseries = OfflineQueryMetadataService.method.getResourceGroupJobTimeseries;

/**
 * @generated from rpc chalk.server.v1.OfflineQueryMetadataService.GetResourceGroupEfficiencyTimeseries
 */
export const getResourceGroupEfficiencyTimeseries = OfflineQueryMetadataService.method.getResourceGroupEfficiencyTimeseries;

/**
 * @generated from rpc chalk.server.v1.OfflineQueryMetadataService.ListOfflineQueryShardPerformanceSummaries
 */
export const listOfflineQueryShardPerformanceSummaries = OfflineQueryMetadataService.method.listOfflineQueryShardPerformanceSummaries;

/**
 * @generated from rpc chalk.server.v1.OfflineQueryMetadataService.CreateOfflineQueryJob
 */
export const createOfflineQueryJob = OfflineQueryMetadataService.method.createOfflineQueryJob;

/**
 * @generated from rpc chalk.server.v1.OfflineQueryMetadataService.CreateModelTrainingJob
 * @deprecated
 */
export const createModelTrainingJob = OfflineQueryMetadataService.method.createModelTrainingJob;

/**
 * @generated from rpc chalk.server.v1.OfflineQueryMetadataService.IngestDataset
 */
export const ingestDataset = OfflineQueryMetadataService.method.ingestDataset;

/**
 * @generated from rpc chalk.server.v1.OfflineQueryMetadataService.RetryOfflineQueryShard
 */
export const retryOfflineQueryShard = OfflineQueryMetadataService.method.retryOfflineQueryShard;

/**
 * @generated from rpc chalk.server.v1.OfflineQueryMetadataService.CancelAsyncOfflineQuery
 */
export const cancelAsyncOfflineQuery = OfflineQueryMetadataService.method.cancelAsyncOfflineQuery;

/**
 * @generated from rpc chalk.server.v1.OfflineQueryMetadataService.GetBatchReport
 */
export const getBatchReport = OfflineQueryMetadataService.method.getBatchReport;

/**
 * @generated from rpc chalk.server.v1.OfflineQueryMetadataService.ListOfflineQueryNames
 */
export const listOfflineQueryNames = OfflineQueryMetadataService.method.listOfflineQueryNames;
